import { Autocomplete, Chip, TableCell, TextField } from "@mui/material"

// Editable free-text tags for a consultant. Sales admins group consultants
// however they like; a routing rule can then hard-gate on a tag. Suggestions
// come from tags already in use, but any free text is allowed.
export function TagsCell(props: {
  tags: string[]
  options: string[]
  onChange: (tags: string[]) => void
}) {
  return (
    <TableCell
      align="left"
      onClick={(event) => event.stopPropagation()}
      sx={{ minWidth: 190 }}
    >
      <Autocomplete
        multiple
        freeSolo
        size="small"
        options={props.options}
        value={props.tags}
        onChange={(_, value) => {
          const cleaned = Array.from(
            new Set(
              value
                .map((tag) => String(tag).trim().toLowerCase())
                .filter((tag) => tag),
            ),
          )
          props.onChange(cleaned)
        }}
        renderTags={(value, getTagProps) =>
          value.map((tag, index) => (
            <Chip
              size="small"
              variant="outlined"
              label={tag}
              {...getTagProps({ index })}
              key={tag}
            />
          ))
        }
        renderInput={(params) => (
          <TextField {...params} variant="standard" placeholder="Add tag" />
        )}
        sx={{ minWidth: 160 }}
      />
    </TableCell>
  )
}
